import * as SwiperNew from '../../js/swipe-4';

export default class ProductBenefits {

    swiper = null;

    swiperElement = null;

    slideClass = 'product-benefits__item';

    wrapperClass = 'product-benefits__list';

    swiperOptions = {
        loop: true,
        slidesPerView: '1',
        centeredSlides: true,
        wrapperClass: 'swiper-wrapper',
        slideClass: 'swiper-slide',
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    };


    constructor() {
        this.addEvents();
    }

    addEvents() {
        const swiperElement = document.querySelector('.product-benefits__wrap');

        if (!swiperElement) return;

        window.addEventListener('load', e => {
            setTimeout(() => {
                // init swiper
                swiperElement.classList.add('swiper-container');
                let swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);
                if (document.body.offsetWidth <= 768 && swiperSlides.length >= 2) {
                    swiperElement.innerHTML += (`<div class="swiper-pagination relative"></div>`);
                    const swiperWrapper = swiperElement.querySelector(`.${this.wrapperClass}`);
                    swiperWrapper.setAttribute('class', 'swiper-wrapper');
                    swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);
                    swiperSlides.forEach((el) => {
                        el.setAttribute('class', 'swiper-slide');
                    });
                    new SwiperNew(swiperElement, this.swiperOptions);
                }
            }, 500)
        });
    }
}

